<template>
  <footer class="the-main-footer">
    <div class="the-main-footer-service">
      <div class="container container-xl">
        <div class="service-list">
          <div
            v-for="service in serviceList"
            :key="service.title"
            class="service"
          >
            <div class="icon-wrapper">
              <a
                :href="service.href"
                target="_blank"
                class="icon-link"
              >
                <img
                  :src="service.icon"
                  :alt="service.alt"
                  :class="['icon', service.className]"
                  loading="lazy"
                />
              </a>
            </div>
            <div class="meta-info">
              <div class="info-title">{{ service.title }}</div>
              <div class="info-caption">{{ service.caption }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-content-container">
      <div class="container container-xl">
        <div class="the-main-footer-content">
          <!-- Mobile-only accordion -->
          <div class="base-collapse _hide-desktop">
            <button
              type="button"
              class="base-collapse-header"
              @click="toggleMenu"
            >
              <div
                :class="[
                  'base-collapse-header-title',
                  { '-is-active': isMenuOpen },
                ]"
              >
                ช่วยเหลือ &amp; ข้อมูลเพิ่มเติม
              </div>
              <div class="base-collapse-header-icon">
                <v-icon
                  size="14"
                  :class="{ '-is-active': isMenuOpen }"
                  class="icon"
                >
                  mdi-chevron-down
                </v-icon>
              </div>
            </button>
            <transition
              name="roll-down"
              @enter="startTransition"
              @after-enter="endTransition"
              @before-leave="startTransition"
              @after-leave="endTransition"
            >
              <div v-show="isMenuOpen" class="base-collapse-content">
                <ul class="menu-list">
                  <li
                    v-for="link in allLinks"
                    :key="link.label"
                    class="menu"
                  >
                    <a :href="link.href" target="_blank" class="link">
                      {{ link.label }}
                    </a>
                  </li>
                </ul>
              </div>
            </transition>
          </div>

          <!-- Mobile-only store locator -->
          <div class="column _hide-desktop">
            <div class="button-store-location-container">
              <a
                href="https://www.bnn.in.th/th/store-locations"
                target="_blank"
                class="button-store-location"
              >
                <div class="icon-wrapper">
                  <svg viewBox="0 0 384 512" class="icon">
                    <path
                      fill="currentColor"
                      d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
                    />
                  </svg>
                </div>
                <span class="button-store-location-label">
                  ค้นหาร้านค้าใกล้คุณ
                </span>
              </a>
            </div>
          </div>

          <!-- Desktop-only banana info -->
          <div class="column banana-info _show-only-desktop">
            <a
              href="https://www.bnn.in.th/th"
              target="_blank"
              class="logo-link"
            >
              <img
                src="@/assets/bnn/footer/banana-black.svg"
                alt="banana"
                class="img-banana"
                loading="lazy"
              />
            </a>
            <div class="label">
              ช้อปสินค้าไอทีได้ง่าย ตลอด 24 ชั่วโมง
            </div>
            <div class="button-store-location-container">
              <a
                href="https://www.bnn.in.th/th/store-locations"
                target="_blank"
                class="button-store-location"
              >
                <div class="icon-wrapper">
                  <svg viewBox="0 0 384 512" class="icon">
                    <path
                      fill="currentColor"
                      d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
                    />
                  </svg>
                </div>
                <span class="button-store-location-label">
                  ค้นหาร้านค้าใกล้คุณ
                </span>
              </a>
            </div>
            <dl class="widget _show-only-desktop">
              <dd class="img-row">
                <a
                  v-for="app in appList"
                  :key="app.name"
                  target="_blank"
                  :href="app.href"
                  class="icon-link"
                >
                  <img
                    :src="app.icon"
                    :alt="app.name"
                    class="icon download-app"
                    loading="lazy"
                  />
                </a>
              </dd>
            </dl>
          </div>

          <!-- Desktop-only "about" column -->
          <dl class="column about _show-only-desktop">
            <dt class="info-title">เกี่ยวกับ BaNANA</dt>
            <dd>
              <ul class="menu-list">
                <li
                  v-for="link in aboutLinks"
                  :key="link.label"
                  class="menu"
                >
                  <a :href="link.href" target="_blank" class="link">
                    {{ link.label }}
                  </a>
                </li>
              </ul>
            </dd>
          </dl>

          <!-- Desktop-only "service" column -->
          <dl class="column services _show-only-desktop">
            <dt class="info-title">บริการ</dt>
            <dd>
              <ul class="menu-list">
                <li
                  v-for="link in serviceLinks"
                  :key="link.label"
                  class="menu"
                >
                  <a :href="link.href" target="_blank" class="link">
                    {{ link.label }}
                  </a>
                </li>
              </ul>
            </dd>
          </dl>

          <!-- Verified-by / social / delivery / mobile-app-download column -->
          <div class="column">
            <dl class="widget">
              <dt class="info-title">Verified by</dt>
              <dd class="img-row">
                <img
                  v-for="item in verifiedByList"
                  :key="item.name"
                  :src="item.icon"
                  :alt="item.name"
                  class="icon"
                  loading="lazy"
                />
              </dd>
            </dl>

            <dl class="stay-connected">
              <dt class="info-title">ติดตามเรา</dt>
              <dd class="icon-list">
                <a
                  v-for="social in socialList"
                  :key="social.name"
                  target="_blank"
                  :aria-label="social.name"
                  :href="social.href"
                  class="icon-link"
                >
                  <img
                    :src="social.icon"
                    :alt="social.name"
                    class="icon-img"
                    loading="lazy"
                  />
                </a>
              </dd>
            </dl>

            <dl class="widget">
              <dt class="info-title">บริการจัดส่ง</dt>
              <dd class="img-row">
                <img
                  v-for="item in deliveryServiceList"
                  :key="item.name"
                  :src="item.icon"
                  :alt="item.name"
                  class="icon"
                  loading="lazy"
                />
              </dd>
            </dl>

            <dl class="widget _hide-desktop">
              <dt class="info-title">ดาวน์โหลดแอปพลิเคชั่น</dt>
              <dd class="img-row">
                <a
                  v-for="app in appList"
                  :key="app.name"
                  target="_blank"
                  :href="app.href"
                  class="icon-link"
                >
                  <img
                    :src="app.icon"
                    :alt="app.name"
                    class="icon download-app"
                    loading="lazy"
                  />
                </a>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-copy-right-container">
      <div class="container container-xl">
        <div class="the-main-footer-copyright">
          <div class="link-group">
            <a
              href="https://www.bnn.in.th/th/pages/terms-of-use"
              target="_blank"
              class="link"
            >
              ข้อกำหนดการใช้
            </a>
            <div class="divider-vertical"></div>
            <a
              href="https://www.bnn.in.th/th/pages/privacy-policy"
              target="_blank"
              class="link"
            >
              นโยบายความเป็นส่วนตัว
            </a>
            <!-- No longer needed, as per the request to remove the cookie management button -->
            <!-- <div class="divider-vertical"></div>
            <button type="button" class="btn-cookie-preferences link">
              การจัดการ Cookies
            </button> -->
          </div>
          <p class="copy-right">
            © Copyright {{ currentYear }} Com7 Public Company Limited
            All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterFullBaNANA',

  data() {
    return {
      isMenuOpen: false,
      isMobileDevice: false,

      serviceList: [
        {
          title: 'ส่งฟรีทั่วไทย',
          caption: 'ช้อปครบ 3,000.- ขึ้นไป',
          alt: 'free shipping',
          className: 'icon-free-shipping',
          href: 'https://www.bnn.in.th/th/pages/shipping',
          icon: require('@/assets/bnn/footer/freeshipping.svg'),
        },
        {
          title: 'ส่งด่วนภายใน 3 ชั่วโมง',
          caption: 'กรุงเทพฯ และพื้นที่ให้บริการ',
          alt: 'fast delivery',
          className: 'icon-fast-delivery',
          href:
            'https://www.bnn.in.th/th/pages/3-hours-speed-service',
          icon: require('@/assets/bnn/footer/fastdelivery.svg'),
        },
        {
          title: 'รับเองที่ร้าน',
          caption: 'รับสินค้าใกล้บ้าน 600 สาขาทั่วประเทศ',
          alt: 'click and collect',
          className: 'icon-click-n-collect',
          href: 'https://www.bnn.in.th/th/pages/click-and-collect',
          icon: require('@/assets/bnn/footer/clickncollect.svg'),
        },
        {
          title: 'เปลี่ยน คืน ง่าย',
          caption: 'ภายใน 7 วัน*',
          alt: 'refund',
          className: 'icon-refund',
          href: 'https://www.bnn.in.th/th/pages/return-policy',
          icon: require('@/assets/bnn/footer/refund.svg'),
        },
      ],

      menuLinks: [
        {
          label: 'ติดต่อเรา',
          href: 'https://www.bnn.in.th/th/pages/contact-us',
        },
        {
          label: 'เกี่ยวกับ BNN.in.th',
          href: 'https://www.bnn.in.th/th/pages/banana-online',
        },
        {
          label: 'สมัครสมาชิก 7CLUB PLUS',
          href: 'https://www.bnn.in.th/th/pages/7club-member',
        },
        {
          label: 'ข้อกำหนดและเงื่อนไข',
          href: 'https://www.bnn.in.th/th/pages/terms-of-use',
        },
        {
          label: 'ร่วมงานกับเรา',
          href: 'https://www.comsevencareer.com/',
        },
        // {
        //   label: 'ขั้นตอนการสมัครสมาชิก BNN.in.th แบบง่ายๆ',
        //   href:
        //     'https://www.bnn.in.th/th/pages/how-to-register-on-bnn',
        // },
        // {
        //   label: 'เช็คเงินสดผ่าน ShopeePay',
        //   href:
        //     'https://www.bnn.in.th/th/pages/how-to-pay-with-shopeepay',
        // },
        {
          label: 'การจัดส่งสินค้า',
          href: 'https://www.bnn.in.th/th/pages/shipping',
        },
        {
          label: 'บริการรับที่ร้านสาขา',
          href:
            'https://www.bnn.in.th/th/pages/1-hr-pick-up-at-store',
        },
        {
          label: 'เงื่อนไขการรับประกันและการเคลม',
          href: 'https://www.bnn.in.th/th/pages/condition',
        },
      ],

      verifiedByList: [
        {
          name: 'dbd',
          icon: require('@/assets/bnn/footer/trustmarkthai-dbd-registered-logo.png'),
        },
        {
          name: 'ocpb',
          icon: require('@/assets/bnn/footer/ocpb.png'),
        },
        {
          name: 'mastercard',
          icon: require('@/assets/bnn/footer/mastercard.png'),
        },
        {
          name: 'visa',
          icon: require('@/assets/bnn/footer/visa.png'),
        },
      ],

      socialList: [
        {
          name: 'facebook',
          href: 'https://com7.co/49PvG34',
          icon: require('@/assets/bnn/footer/social/facebook.png'),
        },
        {
          name: 'instagram',
          href: 'https://com7.co/3ujszjJ',
          icon: require('@/assets/bnn/footer/social/instagram.png'),
        },
        {
          name: 'line',
          href: 'https://com7.co/4d2iF74',
          icon: require('@/assets/bnn/footer/social/line.png'),
        },
        {
          name: 'tiktok',
          href: 'https://com7.co/47EDi6K',
          icon: require('@/assets/bnn/footer/social/tiktok.png'),
        },
        {
          name: 'x',
          href: 'https://com7.co/47Gma0w',
          icon: require('@/assets/bnn/footer/social/x.png'),
        },
        {
          name: 'youtube',
          href: 'https://com7.co/3Gc40bm',
          icon: require('@/assets/bnn/footer/social/youtube.png'),
        },
      ],

      deliveryServiceList: [
        {
          name: 'kerry express',
          icon: require('@/assets/bnn/footer/delivery/kerry-express.png'),
        },
        {
          name: 'dhl',
          icon: require('@/assets/bnn/footer/delivery/dhl.png'),
        },
      ],
    }
  },

  computed: {
    currentYear() {
      return new Date().getFullYear()
    },

    aboutLinks() {
      return this.menuLinks.slice(0, 5)
    },

    serviceLinks() {
      return this.menuLinks.slice(5)
    },

    allLinks() {
      return this.menuLinks
    },

    appList() {
      const webAppLink = 'https://com7.co/bnn-footer-web'

      return [
        {
          name: 'app store',
          href: this.isMobileDevice
            ? webAppLink
            : 'https://apps.apple.com/th/app/banana-online/id1609571295',
          icon: require('@/assets/bnn/footer/download-app/app-store.png'),
        },
        {
          name: 'play store',
          href: this.isMobileDevice
            ? webAppLink
            : 'https://play.google.com/store/apps/details?id=com.comseven.bnn',
          icon: require('@/assets/bnn/footer/download-app/play-store.png'),
        },
      ]
    },
  },

  mounted() {
    this.isMobileDevice = /android|iphone|ipad|ipod|windows phone/i.test(
      navigator.userAgent,
    )
  },

  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },

    startTransition(el) {
      el.style.height = `${el.scrollHeight}px`
    },

    endTransition(el) {
      el.style.height = ''
    },
  },
}
</script>

<style lang="stylus" scoped>
.the-main-footer
    width: 100%
    font-family: $font-family-base

.container
    width: 100%
    max-width: 1176px
    padding: 0 16px
    margin: 0 auto

    @media (min-width: 1024px)
        padding: 0 12px

    &.container-xl
        @media (min-width: 1920px)
            max-width: 1680px

._hide-desktop
    @media (min-width: 1024px)
        display: none !important

._show-only-desktop
    @media (max-width: 1023px)
        display: none !important

// ---- Service strip ----
.the-main-footer-service
    background-color: #f8f8f8

.service-list
    padding-top: 8px
    padding-bottom: 16px

    display: flex
    justify-content: center
    align-items: center
    flex-wrap: wrap

    border-bottom: 1px solid rgba(0, 0, 0, .08)

.service
    position: relative
    padding: 8px 0 16px 0

    display: flex
    justify-content: center
    align-items: center
    flex-direction: column
    flex: 0 50%

    &:not(:nth-child(2n+1))::before
        content: ''
        position: absolute
        left: 0
        top: 50%
        transform: translateY(-50%)
        width: 1px
        height: 64px
        background-color: rgba(0, 0, 0, .08)

    &:not(:nth-last-of-type(-n+2))::after
        content: ''
        position: absolute
        bottom: 0
        left: 50%
        transform: translateX(-50%)
        width: 96px
        height: 1px
        background-color: rgba(0, 0, 0, .08)

    @media (min-width: 1024px)
        padding: 0
        flex: 0 25%
        flex-direction: row

        &:not(:first-child)::before
            content: ''
            position: absolute
            left: 0
            top: 50%
            transform: translateY(-50%)
            width: 1px
            height: 32px
            background-color: rgba(0, 0, 0, .08)

        &:not(:nth-last-of-type(-n+2))::after
            content: none

    .meta-info
        text-align: center

        @media (min-width: 1024px)
            margin-left: 16px
            text-align: left

        .info-title
            font-size: 14px
            font-weight: 700
            line-height: 1.15
            color: #252525

            @media (min-width: 1024px)
                margin-top: 0
                font-size: 16px
                font-weight: bold
                text-align: left

        .info-caption
            font-size: 12px
            font-weight: 600
            line-height: 1.3
            color: rgba(0, 0, 0, .45)

    .icon-wrapper
        display: flex
        justify-content: center
        align-items: center

        width: 56px
        height: 56px

        @media (min-width: 1024px)
            margin: 0
            width: 72px
            height: 72px

        .icon
            width: 100%

            &.icon-free-shipping
                width: 51px

                @media (min-width: 1024px)
                    width: 65px

            &.icon-fast-delivery
                width: 38px

                @media (min-width: 1024px)
                    width: 48px

            &.icon-click-n-collect
                width: 46px

                @media (min-width: 1024px)
                    width: 59px

            &.icon-refund
                width: 44px

                @media (min-width: 1024px)
                    width: 56px

// ---- Main content grid ----
.footer-content-container
    background-color: #f8f8f8
    color: #252525

.the-main-footer-content
    padding: 16px 8px

    display: flex
    flex-direction: column

    font-size: 14px

    @media (min-width: 1024px)
        padding: 32px 0 40px

        align-items: baseline
        flex-direction: row

    > .column
        @media (min-width: 1024px)
            width: 25%

    dl
        margin-bottom: 16px

        &:last-child
            margin-bottom: 16px

        @media (min-width: 1024px)
            margin-bottom: 16px

            &:last-child
                margin-bottom: 0

    .info-title
        margin-bottom: 8px

        font-size: 12px
        font-weight: bold
        line-height: 1.33

        @media (min-width: 1024px)
            font-size: 14px

    .menu
        margin-bottom: 8px

        font-size: 12px
        font-weight: 600
        line-height: 1.33
        color: rgba(0, 0, 0, .7)

        @media (min-width: 1024px)
            font-size: 14px
            font-weight: 500

        .link
            color: rgba(0, 0, 0, .7)
            text-decoration: none

            &:hover
                color: #eba614

// ---- Banana info column ----
.banana-info
    .img-banana
        height: 40px
        width: auto

    .label
        padding-right: 16px

        margin-top: 12px

        font-weight: 500
        line-height: 1.4
        color: rgba(0, 0, 0, .7)

        @media (min-width: 1024px)
            margin: 16px 0

// ---- Menu lists ----
.menu-list
    list-style: none
    margin: 0
    padding: 0

// ---- Mobile accordion ----
.base-collapse
    margin-bottom: 16px

.base-collapse-header
    background-color: transparent
    border: 0
    padding: 0
    width: 100%

    display: flex
    align-items: center
    justify-content: center

    cursor: pointer

    &:focus
        outline: none

.base-collapse-header-title
    flex: 1

    padding: 8px 0

    font-size: 12px
    font-weight: 600
    color: rgba(0, 0, 0, .7)
    text-align: left

    &.-is-active
        font-weight: bold
        color: #252525
        margin-bottom: 8px

.base-collapse-header-icon
    padding: 8px

    display: flex
    align-items: center
    justify-content: center

    .icon
        color: rgba(0, 0, 0, .45)
        transition: transform 0.2s ease

        &.-is-active
            color: #252525
            transform: rotate(-180deg)

.base-collapse-content
    overflow: hidden

// ---- Store locator button ----
.button-store-location-container
    border-top: 1px solid rgba(0, 0, 0, .08)
    padding-top: 16px

    @media (min-width: 1024px)
        border: none
        padding: 0
        margin-bottom: 18px

.button-store-location
    margin: 0 auto
    padding: 4px 16px 4px 8px
    width: fit-content
    height: 34px
    text-decoration: none

    display: flex
    align-items: center

    background-color: transparent

    border: 1px solid #000
    border-radius: 4px

    cursor: pointer

    @media (min-width: 1024px)
        margin: 0

    .icon-wrapper
        width: 24px
        height: 24px

        display: flex
        align-items: center
        justify-content: center

        .icon
            width: 16px
            height: 16px
            color: #252525

    .button-store-location-label
        padding-left: 4px

        font-size: 14px
        color: #252525
        font-weight: 600
        line-height: 1.4

// ---- Widgets (verified-by / delivery / app-download) ----
.widget
    .img-row
        display: flex
        flex-wrap: wrap
        row-gap: 10px

        margin: 12px auto 0

        @media (min-width: 1024px)
            margin: 0

        > .icon-link:not(:last-child)
            margin-right: 16px

        .icon
            max-height: 24px
            width: auto

            &:not(:last-child)
                margin-right: 16px

            &.download-app
                max-height: 30px
                cursor: pointer

// ---- Social ----
.stay-connected
    .icon-link
        color: rgba(0, 0, 0, .45)
        text-decoration: none

        &:not(:last-child)
            margin-right: 16px

        .icon-img
            vertical-align: -3.5px
            width: 24px
            height: 24px

// ---- Copyright bar ----
.footer-copy-right-container
    background-color: #000
    color: rgba(255, 255, 255, .95)
    font-size: 12px

    @media (min-width: 1024px)
        font-size: 14px

.the-main-footer-copyright
    padding: 16px 0 24px 0

    @media (min-width: 1024px)
        width: 100%
        padding: 10px 0

        display: flex
        justify-content: space-between
        align-items: center
        flex-flow: row-reverse

.link-group
    width: 100%

    display: flex
    justify-content: center
    align-items: center

    @media (min-width: 1024px)
        width: auto
        justify-content: space-between

    .link
        color: inherit
        font-weight: 600
        text-decoration: none
        text-align: center
        background: none
        border: none
        padding: 0
        cursor: pointer

    .divider-vertical
        margin: 0 12px
        width: 1px
        height: 24px
        background-color: rgba(255, 255, 255, .25)

.copy-right
    padding: 0 32px
    margin-top: 8px
    margin-bottom: 0

    color: rgba(255, 255, 255, .45)
    font-weight: 600
    line-height: 1.3
    text-align: center

    @media (min-width: 1024px)
        padding: 0
        margin: 0

        color: rgba(255, 255, 255, .95)
        font-weight: 500
        line-height: 1.4

.roll-down-enter-active,
.roll-down-leave-active
    transition: height 0.2s ease
    overflow: hidden

.roll-down-enter,
.roll-down-leave-to
    height: 0 !important
</style>
